import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { eventLogReducer } from './reducer';
import { EventLogStoreEffects } from 'src/app/root-store/event-log-store/effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('event-log', eventLogReducer),
    EffectsModule.forFeature([EventLogStoreEffects]),
  ],
  providers: [EventLogStoreEffects],
})
export class EventLogStoreModule {}
